import classNames from "classnames";
import {Fragment} from "react";

import {calculateAssetPrice} from "../../asset/util/assetUtils";
import Typography, {TypographyProps} from "../typography/Typography";
import {
  FormatNumberOptions,
  formatPrice,
  getUSDFormatterFractionDigits
} from "../../core/util/number/numberUtils";
import {useAssetPrices} from "../../asset/price/context/AssetPriceContext.utils";

type DollarValueProps = Omit<TypographyProps<"div">, "children" | "prefix"> & {
  assetID?: string;
  balance?: null | number;
  usdValue?: null | number;
  fallbackContent?: React.ReactNode;
  testid?: string;
  prefix?: React.ReactNode | null;
  fractionDigits?: Pick<
    FormatNumberOptions,
    "maximumFractionDigits" | "minimumFractionDigits"
  >;
};

function DollarValue({
  testid,
  assetID,
  balance,
  usdValue,
  customClassName,
  fallbackContent = <Fragment />,
  prefix = "≈ ",
  fractionDigits,
  ...typographyProps
}: DollarValueProps) {
  const currentAssetPrices = useAssetPrices();

  let price = usdValue;

  if (!usdValue && currentAssetPrices && assetID && typeof balance === "number") {
    price = calculateAssetPrice(currentAssetPrices, assetID, balance);
  }

  if (typeof price !== "number") {
    return <Fragment>{fallbackContent}</Fragment>;
  }

  const priceFormatter = formatPrice(
    fractionDigits || getUSDFormatterFractionDigits(price)
  );

  return (
    <Typography
      data-testid={testid}
      customClassName={classNames("dollar-value", customClassName)}
      {...typographyProps}>
      {`${prefix || ""} ${priceFormatter(price)}`}
    </Typography>
  );
}

export default DollarValue;
